'use client'

import { useReportWebVitals } from 'next/web-vitals'

export function WebVitals() {
  useReportWebVitals((metric) => {
    // Only log in development
    if (process.env.NODE_ENV === 'development') {
      const vitals = {
        id: metric.id,
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
      }

      // Color code based on rating
      const colors = {
        good: '\x1b[32m', // green
        'needs-improvement': '\x1b[33m', // yellow
        poor: '\x1b[31m', // red
      }
      const color = colors[metric.rating] || '\x1b[0m'
      const reset = '\x1b[0m'

      console.log(`${color}[Web Vitals] ${metric.name}: ${metric.value} (${metric.rating})${reset}`)

      // Specific thresholds
      if (metric.name === 'LCP' && metric.value > 2500) {
        console.warn('⚠️  LCP is poor (>2.5s). Target: <2.5s')
      }
      if (metric.name === 'FID' && metric.value > 100) {
        console.warn('⚠️  FID is poor (>100ms). Target: <100ms')
      }
      if (metric.name === 'CLS' && metric.value > 0.1) {
        console.warn('⚠️  CLS is poor (>0.1). Target: <0.1')
      }
      if (metric.name === 'FCP' && metric.value > 1800) {
        console.warn('⚠️  FCP is poor (>1.8s). Target: <1.8s')
      }
      if (metric.name === 'TTFB' && metric.value > 800) {
        console.warn('⚠️  TTFB is poor (>800ms). Target: <800ms')
      }
      if (metric.name === 'INP' && metric.value > 200) {
        console.warn('⚠️  INP is poor (>200ms). Target: <200ms')
      }
    }
  })

  return null
}
